import React from "react";
import startCase from "lodash/startCase";

const BankAccountItem = ({ account }) => {
  const { logoURL, mask, institutionName, type } = account;
  // currently all accounts here will show up as no matches
  return (
    <div className="flex justify-start items-center bg-white bg-opacity-10 pl-5 pr-2 my-1 border-box h-12 overflow-hidden">
      <span className="flex justify-center h-full truncate items-center text-lg font-extralight">
        <span className="mr-2" style={{ height: "36px", width: "36px" }}>
          {logoURL && (
            <img
              src={logoURL}
              alt={institutionName}
              className="w-full h-full"
            />
          )}
        </span>
        <span className="text-left truncate">
          <p className="text-xxs h-4"> </p>
          <p className="truncate text-md leading-none mt-auto">
            {institutionName}
          </p>
          <p className="text-xxs truncate">{`${startCase(type)} (${(
            mask || ""
          ).slice(-4)})`}</p>
        </span>
      </span>
    </div>
  );
};

export default BankAccountItem;